import { render, staticRenderFns } from "./LargeCard.vue?vue&type=template&id=4849c46d&scoped=true&"
import script from "./LargeCard.vue?vue&type=script&lang=ts&"
export * from "./LargeCard.vue?vue&type=script&lang=ts&"
import style0 from "./LargeCard.vue?vue&type=style&index=0&id=4849c46d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4849c46d",
  null
  
)

export default component.exports